import { render, staticRenderFns } from "./PostSignature.vue?vue&type=template&id=4684fbb6&scoped=true&"
import script from "./PostSignature.vue?vue&type=script&lang=ts&"
export * from "./PostSignature.vue?vue&type=script&lang=ts&"
import style0 from "./PostSignature.vue?vue&type=style&index=0&id=4684fbb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684fbb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
